export default __webpack_public_path__ + "static/media/1.8f756cbb.jpg";